import React, { Component, createRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import type { AgGridReact as AgGridReactType } from 'ag-grid-react';
import { GridApi, AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { Button, ButtonGroup } from 'react-bootstrap';
import { faFileCsv, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import './AGDataGrid.css'; // Custom styles for grid

// Register Community Modules
ModuleRegistry.registerModules([AllCommunityModule]);

type AGDataGridProps = {
  columnDefs: any[];
  rowData: any[];
  title?: string;
  rowClassRules?: any;
};

type AGDataGridState = {
  pageSize: number;
};

export class AGDataGrid extends Component<AGDataGridProps, AGDataGridState> {
  gridRef = createRef<AgGridReactType>();

  state: AGDataGridState = {
    pageSize: 100,
  };

  onExportCSV = () => {
    this.gridRef.current?.api.exportDataAsCsv();
  };

  onExportExcel = () => {
    this.gridRef.current?.api.exportDataAsExcel();
  };

  onPageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const pageSize = parseInt(e.target.value, 10);
    this.setState({ pageSize });
    (this.gridRef.current?.api as any).setPaginationPageSize(pageSize);
  };

  onGridReady = (params: any) => {
    setTimeout(() => {
      try {
        params.api.refreshCells(); // Or autoSizeAllColumns() if preferred
      } catch (e) {
        console.warn('Grid resizing failed:', e);
      }
    }, 50);
  };

  onCellValueChanged = (params: any) => {
    console.log('Cell updated:', params.colDef.field, '→', params.newValue);
  };

  render() {
    const { title = 'AG Data Grid', columnDefs, rowData, rowClassRules } = this.props;

    return (
      <div style={{ height: '320px', width: '100%', display: 'flex', flexDirection: 'column', fontFamily: "'Inter', 'Segoe UI', system-ui" }}>
        <div className="p-3 bg-light d-flex justify-content-between align-items-center border-bottom">
          <h5 className="mb-0">{title}</h5>
          <ButtonGroup>
            <Button variant="outline-primary" size="sm" onClick={this.onExportCSV}>
              <FontAwesomeIcon icon={faFileCsv} className="me-1" /> CSV
            </Button>
            <Button variant="outline-success" size="sm" onClick={this.onExportExcel}>
              <FontAwesomeIcon icon={faFileExcel} className="me-1" /> Excel
            </Button>
          </ButtonGroup>
        </div>

        <div className="ag-theme-quartz custom-grid-theme" style={{ flexGrow: 1, height: '100%', maxHeight: '500px' }}>
          <AgGridReact
            ref={this.gridRef}
            rowData={rowData}
            columnDefs={columnDefs}
            defaultColDef={{
              resizable: true,
              sortable: true,
              filter: true,
              minWidth: 150,
              wrapHeaderText: false,
              autoHeaderHeight: true,
              cellStyle: {
    whiteSpace: 'nowrap', // ⛔ prevent wrapping
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      userSelect: 'text',    // ✅ allow text selection
  },
            }}
            rowClassRules={rowClassRules}
            rowHeight={36}
            pagination
            paginationPageSize={this.state.pageSize}
            onGridReady={this.onGridReady}
            onCellValueChanged={this.onCellValueChanged}
            animateRows
            sideBar={{
              toolPanels: ['columns'],
              defaultToolPanel: 'columns',
              position: 'left',
              hiddenByDefault: false,
            }}
            enableBrowserTooltips
            rowSelection="multiple"
            enableCellTextSelection={true}         // ✅ allows you to select text in cells
            suppressClipboardPaste={true}          // ✅ allows copying but not pasting (optional)
            //enableCellTextSelection
             suppressRowClickSelection={false}
        suppressCellFocus={false}
     
          />
        </div>
      </div>
    );
  }
}
